import { SubClauseWithCondition } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isObjectRecord } from "./isObjectRecord";
import { isWhereClauseCondition } from "./isWhereClauseCondition";

/**
 * Type guard to check if a value is a SubClauseWithCondition.
 *
 * @param obj - The value to check
 * @returns True if the value is a SubClauseWithCondition
 */
export const isSubClauseWithCondition = (obj: unknown): obj is SubClauseWithCondition => {
  if (!isObjectRecord(obj)) return false;
  const objectRecord = obj;
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  // Check id is a non-blank string
  if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;

  // Check subClauseId is "" (empty string for non-referenced clauses)
  if (objectRecord.subClauseId !== "") return false;

  // Must have a valid condition
  if (!isWhereClauseCondition(objectRecord.condition)) return false;

  // Must not have compoundExpression property
  if (objectRecord.compoundExpression !== undefined) return false;

  return true;
};
